import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <Layout>
      <div className="container flex flex-col items-center justify-center min-h-[80vh] space-y-8 text-center">
        <div className="space-y-6">
          <div className="relative">
            <h1 className="text-8xl font-bold tracking-tighter animate-pulse">404</h1>
            <div className="absolute -top-6 -right-6 w-20 h-20 bg-primary/10 rounded-full blur-xl animate-pulse"></div>
            <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-secondary/10 rounded-full blur-lg animate-pulse delay-100"></div>
          </div>
          <div className="space-y-4">
            <h2 className="text-4xl font-semibold tracking-tight">Page Not Found</h2>
            <p className="text-xl text-muted-foreground max-w-md mx-auto">
              Oops! The page you're looking for seems to have wandered off into the digital void.
            </p>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-4">
          <Button asChild size="lg" variant="default">
            <a href="/">Return Home</a>
          </Button>
          <Button asChild size="lg" variant="outline">
            <a href="/support">Contact Support</a>
          </Button>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
